import { render, staticRenderFns } from "./RadioFormElement.component.vue?vue&type=template&id=21957456"
import script from "./RadioFormElement.component.vue?vue&type=script&lang=js"
export * from "./RadioFormElement.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports